/**
 * When the operator is actually needed for a 2FA code.
 *
 * The request has three live states: `pending` (no code yet), `ready` (a code
 * is stored and the bot is about to type it) and `consumed`. The bot's own
 * readers (mailbox, Zoom SMS, voicemail) submit into `ready` themselves, so
 * offering manual entry there flashed a "Pass 2FA" button for the second
 * between the reader finding the code and the bot consuming it.
 */
export type TwoFaLike = {
  status?: string | null;
  auto_until?: string | null;
};

const AUTO_BOT_STATUS = "2FA";

export function isTwoFaAutoPhase(
  twoFa: TwoFaLike | null | undefined,
  manualOverride = false,
): boolean {
  if ((twoFa?.status || "").toLowerCase() !== "pending") return false;
  if (manualOverride) return false;
  const until = twoFa?.auto_until ? Date.parse(twoFa.auto_until) : NaN;
  return Number.isFinite(until) && Date.now() < until;
}

/** A code is stored: the bot is typing it, nobody should send a second one. */
export function isTwoFaCodeSubmitted(twoFa: TwoFaLike | null | undefined): boolean {
  return (twoFa?.status || "").toLowerCase() === "ready";
}

/** Manual entry is the only way forward: no code, and no reader working on it. */
export function isTwoFaCodeNeeded(
  botWorkStatus: string | null | undefined,
  twoFa: TwoFaLike | null | undefined,
  manualOverride = false,
): boolean {
  if ((botWorkStatus || "").toUpperCase() !== AUTO_BOT_STATUS) return false;
  if ((twoFa?.status || "").toLowerCase() !== "pending") return false;
  return !isTwoFaAutoPhase(twoFa, manualOverride);
}
